import React from 'react';
import { JiraSoftwareBoardAri } from '@atlassian/ari/jira-software/board';
import { useIntl } from '@atlassian/jira-intl';
import { integrationTypes } from '@atlassian/jira-share-button/src/constants.tsx';
import { ShareButton } from '@atlassian/jira-share-button/src/index.tsx';
import { useCloudId } from '@atlassian/jira-tenant-context-controller/src/components/cloud-id/index.tsx';
import messages from './messages.tsx';

type Props = {
	boardId: number | string;
};

const REPORT_SHARE_CONTENT_TYPE = 'report';

export const JswShareButton = ({ boardId }: Props) => {
	const cloudId = useCloudId();
	const { formatMessage } = useIntl();

	if (!boardId) {
		return null;
	}

	const objectAri = JiraSoftwareBoardAri.create({
		boardId: String(boardId),
		siteId: cloudId,
	}).toString();

	return (
		<ShareButton
			integrationType={integrationTypes.CLASSIC_BOARD}
			triggerButtonStyle="icon-only"
			productId="jira"
			subProductId="jira-software"
			shareTitle={formatMessage(messages.shareTitle)}
			shareFormTitle={formatMessage(messages.shareFormTitle)}
			shareContentType={REPORT_SHARE_CONTENT_TYPE}
			objectAri={objectAri}
			copyTooltipText={formatMessage(messages.shareTooltipText)}
			shareFormHelperMessage={formatMessage(messages.shareHelperMessage)}
			poSpotlightShareButtonId="po-spotlight-share-button"
		/>
	);
};
